import { getFontFamily, getFontSize, getFontStyle, getFontWeight, getTextAlign, getLineHeight, } from '../../typography/typography.alias';
import { getHeight, getWidth } from '../../sizes/sizes.alias';
import { getColor, getBorderColor, getOutlineColor, getBackgroundColor, } from '../../colors/colors.alias';
import { getBorderRadius, getBorderWidth, getBorderStyle, getOutlineOffset, getOutlineStyle, getOutlineWidth, } from '../../borders/borders.alias';
import { constants as InlineMessage } from '../InlineMessage';
import { constants as Icon } from '../Icon';
import { VARIANT_DEFAULT, VARIANT_CHARACTER, VARIANT_MULTILINE, ELEMENT_INPUT, ELEMENT_PLACEHOLDER, ELEMENT_INLINE_MESSAGE, ELEMENT_ICON, INTERACTION_STATE_HOVER, INTERACTION_STATE_FOCUS_VISIBLE, DATA_STATE_VALID, DATA_STATE_INVALID, DATA_STATE_READ_ONLY, } from '../../constants';
export const constants = Object.freeze({
    NAME: 'Input',
    variants: {
        VARIANT_DEFAULT,
        VARIANT_CHARACTER,
        VARIANT_MULTILINE,
    },
    elements: {
        ELEMENT_INPUT,
        ELEMENT_PLACEHOLDER,
        ELEMENT_INLINE_MESSAGE,
        ELEMENT_ICON,
    },
    dataStates: {
        DATA_STATE_VALID,
        DATA_STATE_INVALID,
        DATA_STATE_READ_ONLY,
    },
    interactionStates: {
        INTERACTION_STATE_HOVER,
        INTERACTION_STATE_FOCUS_VISIBLE,
    },
});
export default function getInput(transformer, config) {
    const borderStyle = getBorderStyle(transformer, config);
    const borderColor = getBorderColor(transformer, config);
    const borderWidth = getBorderWidth(transformer, config);
    const fontFamily = getFontFamily(transformer, config);
    const color = getColor(transformer, config);
    const fontSize = getFontSize(transformer);
    const lineHeight = getLineHeight(transformer);
    const height = getHeight(transformer);
    const outlineOffset = getOutlineOffset(transformer, config);
    const outlineWidth = getOutlineWidth(transformer, config);
    const outlineColor = getOutlineColor(transformer, config);
    const outlineStyle = getOutlineStyle(transformer, config);
    const borderRadius = getBorderRadius(transformer, config);
    const width = getWidth(transformer);
    const fontWeight = getFontWeight(transformer);
    const textAlign = getTextAlign(transformer);
    const backgroundColor = getBackgroundColor(transformer, config);
    const fontStyle = getFontStyle(transformer, config);
    return Object.freeze({
        constants,
        elements: {
            [ELEMENT_INPUT]: {
                styles: {
                    fontFamily: fontFamily.body.value,
                    fontSize: fontSize.body.m.value,
                    lineHeight: lineHeight.form.input.get(fontSize.body.m.value),
                    color: color.text.default.value,
                    borderRadius: borderRadius.form.input.value,
                    borderWidth: borderWidth.form.input.default.value,
                    borderColor: borderColor.form.input.default.value,
                    borderStyle: borderStyle.form.input.value,
                    height: height.form.input.default.value,
                    backgroundColor: backgroundColor.form.input.default.value,
                },
                variants: {
                    [VARIANT_MULTILINE]: {
                        styles: {
                            height: height.form.textarea.default.value,
                        },
                    },
                    [VARIANT_CHARACTER]: {
                        styles: {
                            height: height.form.characterInput.default.value,
                            width: width.form.characterInput.default.value,
                            fontSize: fontSize.body.l.value,
                            lineHeight: lineHeight.form.input.get(fontSize.body.l.value),
                            fontWeight: fontWeight.form.characterInput.get(fontFamily.form.characterInput.value),
                            textAlign: textAlign.form.characterInput.value,
                            fontFamily: fontFamily.form.characterInput.value,
                        },
                    },
                },
                interactionStates: {
                    [INTERACTION_STATE_HOVER]: {
                        styles: {
                            borderColor: borderColor.form.input.interactionStates[INTERACTION_STATE_HOVER].value,
                        },
                    },
                    [INTERACTION_STATE_FOCUS_VISIBLE]: {
                        styles: {
                            outlineWidth: outlineWidth.default.value,
                            outlineStyle: outlineStyle.default.value,
                            outlineOffset: outlineOffset.default.value,
                            outlineColor: outlineColor.default.interactionStates[INTERACTION_STATE_FOCUS_VISIBLE].value,
                        },
                    },
                },
                dataStates: {
                    [DATA_STATE_INVALID]: {
                        styles: {
                            height: height.form.input.dataStates[DATA_STATE_INVALID].value,
                            borderWidth: borderWidth.form.input.dataStates[DATA_STATE_INVALID].value,
                            borderColor: borderColor.form.input.dataStates[DATA_STATE_INVALID].value,
                        },
                    },
                    [DATA_STATE_READ_ONLY]: {
                        styles: {
                            borderColor: borderColor.form.input.dataStates[DATA_STATE_READ_ONLY].value,
                        },
                    },
                },
            },
            [ELEMENT_INLINE_MESSAGE]: {
                components: {
                    [InlineMessage.NAME]: {
                        variant: InlineMessage.variants.VARIANT_DEFAULT,
                    },
                },
            },
            [ELEMENT_ICON]: {
                styles: {
                    color: color.form.input.icon.value,
                },
                components: {
                    [Icon.NAME]: {
                        variant: Icon.variants.VARIANT_MEDIUM,
                    },
                },
            },
            [ELEMENT_PLACEHOLDER]: {
                styles: {
                    color: color.form.placeholder.value,
                    fontStyle: fontStyle.form.placeholder.value,
                },
            },
        },
    });
}
